// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { SurveyInfoResponseDTO } from "../../api/backend-openapi";

export interface SurveyFormProps {
  editMode?: boolean;
}

export interface SurveyFormSectionProps extends SurveyFormProps {
  survey?: SurveyInfoResponseDTO | null;
  showRequired?: boolean;
}

export enum SurveyWorkflowStatus {
  PUBLISHED = "PUBLISHED",
  VALIDATION = "VALIDATION",
  VALIDATED = "VALIDATED",
  REFUSED = "REFUSED",
  SAVED = "SAVED"
}

export enum SurveyWorkflowType {
  mark = "mark",
  multiple = "multiple",
  simple = "simple",
  freetext = "freetext"
}

export interface Question {
  templateId?: number;
  id?: string;
  type: SurveyWorkflowType;
  label: string;
  maxAnswers?: number;
  answerChoice: Answer[];
  optional?: boolean;
}

export interface Answer {
  id?: string;
  label: string;
}

export interface SurveyBlockProps extends SurveyFormProps {
  readOnly?: boolean;
  indexQuestion: number;
  question: Question;
  handleAddQuestion: (question: Question, index?: number) => void;
  handleUpdateQuestion: (question: Question, index: number) => void;
  handleDeleteQuestion: (index: number) => void;
  handleAscendQuestion?: (index: number) => void;
  handleDescendQuestion?: (index: number) => void;
}
export interface SurveyAnswerBlockProps extends SurveyFormProps {
  readOnly?: boolean;
  indexQuestion: number;
  indexAnswer: number;
  answer: Answer;
  handleDeleteAnswer: (index: number) => void;
  handleUpdateAnswer: (answer: Answer, index: number) => void;
}

export interface SurveyBlocksProps extends SurveyFormProps {
  questions: Question[];
  setQuestions: (questions: Question[]) => void;
}

export interface SurveyAddBlockButtonProps {
  buttonLabel: string;
  index?: number;
  handleAddQuestion: (question: Question, index?: number) => void;
}

export interface SurveySurveyAddBlockButtonProps {
  buttonLabel: string;
  index?: number;
  handleAddAnswer: (answer: Answer, index?: number) => void;
}

export interface QuestionTemplateDTO {
  id: number;
  name: string;
}

export interface Field {
  name: string[];
  value: any;
}

export interface SurveyRefusedFormProps {
  surveyId: string;
}

export interface SurveyEditFormProps extends SurveyFormProps {
  surveyId: string;
  setEditMode: (editMode: boolean) => void;
  canEdit: boolean;
  canValidate: boolean;
  canDelete: boolean;
}
